export const isEmptyPage = (slug: string): boolean =>
  !slug || !!slug.match(/^(english-empty-page|enghlish-empty-page)-/)
